import type { Transaction, Auth } from 'oscar-typedef'
import WepinBackendAPI from '@/networks/api/wepin/WepinBackendAPI'
import {
  type Account,
  type ITransactionExecutor,
  type EncUVD,
  NearPrepareData,
  type NearSendExtraData,
} from '@/types'

export class NearCoinTransactionExecutor implements ITransactionExecutor {
  private account: Account

  constructor(params: { account: Account }) {
    this.account = params.account
  }

  async getPrepareData(params: {
    to: string
    amount: string
  }): Promise<NearPrepareData> {
    const data =
      await WepinBackendAPI.getInstance().transaction.getTransactionPrepareData(
        {
          accountId: this.account.id,
          to: params.to,
          amount: params.amount,
        },
      )
    if (!data.detail) {
      throw new Error('No detail data for prepare')
    }
    return new NearPrepareData({
      nonce: data.detail.nonce,
      blockHash: data.detail.blockHash,
      fee: data.detail.fee,
      registered: data.detail.registered ?? 'completed',
    })
  }

  async sign(params: {
    to: string
    amount: string
    encUVD: EncUVD
    extraData: NearSendExtraData
    otpCode?: Auth.VerifyCode.Request.Body
  }): Promise<Transaction.Sign.Response.Body> {
    const result = await WepinBackendAPI.getInstance().transaction.sign({
      type: 'transaction',
      walletId: this.account.walletId,
      accountId: this.account.id,
      pin: params.encUVD,
      txData: {
        txType: 'transfer',
        to: params.to,
        from: this.account.address,
        amount: params.amount,
        nonce: params.extraData.nonce,
        blockHash: params.extraData.blockHash,
        fee: params.extraData.fee,
        registered: params.extraData.registered,
      },
      otpCode: params.otpCode,
    })
    return result
  }

  async broadcast(params: {
    signResponse: Transaction.Sign.Response.Body
  }): Promise<Transaction.BroadcastTransaction.Response.Body> {
    // @TODO Near broadcast
    return await WepinBackendAPI.getInstance().transaction.broadcastTransaction(
      {
        walletId: this.account.walletId,
        accountId: this.account.id,
        transaction: params.signResponse.transaction,
        signatureResult: params.signResponse.signatureResult,
      },
    )
  }
}
